import { render, staticRenderFns } from "./project-form.vue?vue&type=template&id=7b87c370&scoped=true&"
import script from "./project-form.vue?vue&type=script&lang=js&"
export * from "./project-form.vue?vue&type=script&lang=js&"
import style0 from "./project-form.vue?vue&type=style&index=0&id=7b87c370&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b87c370",
  null
  
)

export default component.exports